module.exports = __webpack_public_path__ + "static/ygap-0f2e1c7b828569fefbe225f28066b8e7.png";